import {
    type OrganicStat,
    type OrganicStatsResponseDimensionEntry,
    type UserDimension,
} from "../../gql-generated/types";

export const ejectAudienceStats = (
    data: readonly OrganicStatsResponseDimensionEntry[] | undefined,
    dimension: UserDimension,
): readonly OrganicStat[] | undefined => data?.find(({ field }) => field?.reportDimension === dimension)?.statsList;
